import {ColumnsType} from 'antd/lib/table';
import moment from 'moment';
import IntlMessages from 'src/domain/utility/IntlMessages';
import {ICampaignHistory} from 'src/shared/services/campaigns/dto/campaign-list';

const TableColumns = (): ColumnsType<any> => {
  return [
    {
      title: <IntlMessages id='common.email' />,
      dataIndex: 'Email',
      key: 'Email',
    },
    {
      title: <IntlMessages id='mailing.sentDate' />,
      dataIndex: 'SentDate',
      key: 'SentDate',
      className: 'col-nowrap',
      render: (text: string, record: ICampaignHistory) => (
        <>{moment(record.SentDate).format('DD/MM/YYYY')}</>
      ),
    },
  ];
};

export default TableColumns;
